var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 22V13.9614C9.5 13.3271 10.0037 12.813 10.625 12.813H15.125C15.7463 12.813 16.25 13.3271 16.25 13.9614V22M3.875 19.7032V11.0226C3.875 9.64488 4.48082 8.33989 5.52543 7.46745L11.4502 2.51916C12.279 1.82695 13.471 1.82694 14.2998 2.51916L20.2246 7.46745C21.2692 8.33989 21.875 9.64488 21.875 11.0226V19.7032C21.875 20.9717 20.8676 22 19.625 22H17.375H8.375H6.125C4.88236 22 3.875 20.9717 3.875 19.7032Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a4110eaac613a35ed906a09da75df03a.svg";
export { ForwardRef as ReactComponent };